import { CardActionArea, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { StyledCardContentDescription, StyledCardMedia } from "@framework/styled";
import type { IToken } from "@framework/types";
import { Card } from "@dzambalaorg/ui-kit";

import { TokenLendButton } from "../../../../../../components/buttons";
import { RarityBadge } from "../../../../../../components/common/badge";

interface IRentTokenListItemProps {
  token: IToken;
}

export const RentTokenListItem = (props: IRentTokenListItemProps) => {
  const { token } = props;

  return (
    <Card>
      <CardActionArea component={RouterLink} to={`/erc721/tokens/${token.id}/view`}>
        <RarityBadge token={token} />
        <Card.Header title={token.template!.title} />
        <StyledCardMedia image={token.template!.imageUrl} />
        <Card.Content>
          <StyledCardContentDescription>
            <RichTextDisplay data={token.template!.description} />
          </StyledCardContentDescription>
        </Card.Content>
      </CardActionArea>
      <Card.Footer>
        <Grid container alignItems="center">
          <Grid size={{ xs: 12 }}>
            <TokenLendButton token={token} />
          </Grid>
        </Grid>
      </Card.Footer>
    </Card>
  );
};
